import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 配送種別のインポート履歴の検索条件
 */
export const shipmentCategoryImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(SHIPMENT_CATEGORY_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type ShipmentCategoryImportJobsSearch = InferOutput<
  typeof shipmentCategoryImportJobsSearchSchema
>
